import { bracketsSlice, groupsSlice, stagesSlice } from './stages';

import { combineReducers } from '@reduxjs/toolkit';
import tourneyChampionship from './championship';
import { availableTournamentsSlice } from 'modules/tournaments/store/available-tournaments';

const tourneysReducer = combineReducers({
  championship: tourneyChampionship,
  stages: stagesSlice.reducer,
  groups: groupsSlice.reducer,
  brackets: bracketsSlice.reducer,
  availableTournaments: availableTournamentsSlice.reducer
});

export default tourneysReducer;
